import { useReturnStore } from '@src/stores/returnStore';
import React from 'react';
import { getFeatureSwitchStatic } from '@src/utils/general';
import { RETURN_METHOD } from '@src/constants/general';
import ItemReturnMethod from './ItemReturnMethod';

interface SplitReturnMethodOptionsProps {
  showItemErrors?: boolean;
}

const SplitReturnMethodOptions = React.forwardRef<
  HTMLDivElement,
  SplitReturnMethodOptionsProps
>(({ showItemErrors = false }, ref) => {
  const selectedItems = useReturnStore((state) => state.selectedItems);

  // SORIS is all-or-nothing across the selection: offer it only when every
  // selected item qualifies, otherwise every item falls back to plain In-Store.
  // Derived here (once) and passed down so the per-item screen applies the same
  // rule the whole-order screen uses via every(SORIS).
  const sorisForSelection = Boolean(
    getFeatureSwitchStatic('allowSORIS') &&
      selectedItems.length > 0 &&
      selectedItems.every(
        (item) => item.eligibilities?.[RETURN_METHOD.SORIS] === true,
      ),
  );

  return (
    <div ref={ref} className="sui-flex sui-flex-col sui-gap-[48px]">
      {selectedItems.map((item, index) => {
        return (
          <ItemReturnMethod
            key={index}
            item={item}
            showError={showItemErrors}
            sorisForSelection={sorisForSelection}
          />
        );
      })}
    </div>
  );
});

export default SplitReturnMethodOptions;
